import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { VBox } from '../../../components/Box';
import { Modal, ModalControls } from '../../../components/Modal';
import { FormField } from '../../../components/FormFields';
import { Button } from '../../../components/Buttons';
import { Dropdown } from '../../../components/Dropdown';
import { setCompanyProperty } from '../../Companies/actions';
import cn from 'classnames';

import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import styles from './InvoicePaymentConditionModal.module.css';

const STATE = {
  value: null,
};

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }

  .drop-down {
    width: 300px;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class InvoicePaymentConditionModalComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
    this.props.onReset();
  }

  get options() {
    const options = [
      { label: this.lbl('company.property.vindat_paymentcondition.prior_to'), value: 'prior_to' },
      { label: this.lbl('company.property.vindat_paymentcondition.by_return'), value: 'by_return' },
    ];
    return options;
  }

  get value() {
    const value = this.options.find(o => o.value == this.state.value);
    return value;
  }

  render() {
    return (
      <Container>
        <ModalComponent className={styles.modal} onClose={this.reset.bind(this)} title={this.lblStr('company.property.vindat_paymentcondition')}>
          <div className={styles.container}>
            <Dropdown
              className={cn("drop-down", styles.dropdown)}
              options={this.options}
              value={this.state.value}
              onChange={pair => this.setState({ value: pair.value })}
            />
          </div>

          <ButtonComponent
            style={'ButtonSoftPrimary'}
            disabled={!this.state.value}
            onClick={() =>
              this.props.onConfirm(this.props.outgoingCompany?.id, 'vindat_paymentcondition', this.state.value, result => {
                if (result.id) {
                  this.props.onClose();
                }
              })
            }
          >
            {this.lbl('confirm')}
          </ButtonComponent>
        </ModalComponent>
      </Container>
    );
  }
}

InvoicePaymentConditionModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  company: PropTypes.object,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    onConfirm(companyId, name, value, callback) {
      dispatch(setCompanyProperty(companyId, name, value, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const InvoicePaymentConditionModal = compose(withConnect, withRouter, injectIntl)(InvoicePaymentConditionModalComp);
